function cleanHighlightedFeaturesTab() {
  document.querySelectorAll('.product__block--collapsible_tab').forEach(tab => {
    const headingWrapper = tab.querySelector('summary');
    const contentWrapper = tab.querySelector('.accordion-details__content');

    if (!headingWrapper || !contentWrapper) return;

    const headingText = (headingWrapper.querySelector('h2')?.innerText || '').trim().toLowerCase();

    if (headingText.includes('highlighted features')) {
      const lists = contentWrapper.querySelectorAll('ul, ol');

      lists.forEach(list => {
        let removedCount = 0;

        list.querySelectorAll('li').forEach((item, index) => {
          const bounds = item.getBoundingClientRect();
          const visualText = item.textContent || '';
          const cleanedText = visualText.replace(/\s|\u00A0/g, '');
          const isEffectivelyEmpty = bounds.height < 5 || cleanedText.length === 0;

          console.log(`LI ${index + 1}:`, `"${visualText}"`, bounds, '=>', isEffectivelyEmpty ? '❌ REMOVE' : '✅ KEEP');

          if (isEffectivelyEmpty) {
            item.remove();
            removedCount++;
          }
        });

        // If all list items were removed, replace list with fallback message
        if (list.querySelectorAll('li').length === 0) {
          const fallback = document.createElement('p');
          fallback.innerText = 'Feature highlights coming soon!';
          fallback.style.fontStyle = 'italic';
          fallback.style.color = '#555';
          list.replaceWith(fallback);
        }
      });
    }
  });
}

const observer = new MutationObserver((mutations, obs) => {
  const hasTargetTab = [...document.querySelectorAll('.product__block--collapsible_tab summary h2')]
    .some(h2 => h2.innerText.trim().toLowerCase().includes('highlighted features'));

  if (hasTargetTab) {
    setTimeout(() => {
      cleanHighlightedFeaturesTab();
      obs.disconnect();
    }, 400);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
